(() => {
  // Header: scroll durumu
  const header = document.querySelector('[data-header]');
  if (header) {
    addEventListener('scroll', () => header.classList.toggle('scrolled', scrollY > 40), { passive: true });
  }

  // Scroll reveal
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.reveal').forEach(el => io.observe(el));

  // Sayaç animasyonu
  const co = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (!e.isIntersecting) return;
      co.unobserve(e.target);
      const el = e.target, target = +el.dataset.count || 0, dur = 1400, t0 = performance.now();
      const tick = now => {
        const p = Math.min(1, (now - t0) / dur);
        el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3))).toLocaleString('en-US');
        if (p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    });
  }, { threshold: 0.6 });
  document.querySelectorAll('[data-count]').forEach(el => co.observe(el));

  // Varyant seçimi: fiyat / sku / stok güncelle
  document.querySelectorAll('select[name="id"]').forEach(sel => {
    sel.addEventListener('change', () => {
      const o = sel.selectedOptions[0];
      if (!o) return;
      const price = document.querySelector('[data-price]');
      const compare = document.querySelector('[data-compare]');
      const sku = document.querySelector('[data-sku]');
      const atc = document.querySelector('[data-atc]');
      if (price && o.dataset.price) price.textContent = o.dataset.price;
      if (compare) compare.textContent = o.dataset.compare || '';
      if (sku && o.dataset.sku) sku.textContent = o.dataset.sku;
      if (atc) {
        const ok = o.dataset.available === 'true';
        atc.disabled = !ok;
        atc.textContent = ok ? atc.dataset.label : 'Sold out';
      }
    });
  });

  // Galeri: küçük görsele tıklayınca büyüğü değiştir
  document.addEventListener('click', e => {
    const t = e.target.closest('[data-thumb]');
    if (!t) return;
    const main = document.querySelector('[data-main-image]');
    if (!main) return;
    main.src = t.dataset.full;
    main.removeAttribute('srcset');
    document.querySelectorAll('[data-thumb].active').forEach(x => x.classList.remove('active'));
    t.classList.add('active');
  });

  // Adet +/- butonları
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-step]');
    if (!b) return;
    const input = b.parentElement.querySelector('input');
    if (!input) return;
    const min = input.min === '' ? 1 : +input.min;
    input.value = Math.max(min, (+input.value || min) + +b.dataset.step);
  });

  // Filtre / sıralama: değişince formu gönder
  document.querySelectorAll('[data-autosubmit]').forEach(form => {
    form.addEventListener('change', e => {
      if (e.target.type === 'number') return; // fiyat aralığında Uygula butonu kullanılır
      form.submit();
    });
  });
})();
